(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promo-code"] && !Shopify.designMode) return;
  try {
    (function () {
    // Copie synchrone d'abord (dans le geste du clic), navigator.clipboard en secours :
    // dans un navigateur intégré, writeText peut rester en attente sans jamais répondre.
    function copier(texte) {
      var ok = false, zone = document.createElement('textarea');
      zone.value = texte; zone.setAttribute('readonly', '');
      zone.style.cssText = 'position:fixed;top:-9999px;opacity:0';
      document.body.appendChild(zone); zone.select();
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(zone);
      if (ok) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texte);
      return Promise.reject();
    }

    // Shopify sert les pages depuis son cache : le code choisi par Liquid peut dater de la
    // veille au changement de période. On recalcule donc ici, à l'heure réelle.
    // Test : ?promo_date=2026-11-07T10:00 simule une date (affichage seul).
    function maintenant() {
      var m = /[?&]promo_date=([^&]+)/.exec(window.location.search);
      var t = m ? new Date(decodeURIComponent(m[1])).getTime() : NaN;
      return Math.floor((isNaN(t) ? Date.now() : t) / 1000);
    }

    function actualiser() {
      var t = maintenant();
      document.querySelectorAll('.promo-code[data-cal]').forEach(function (b) {
        var d = (b.getAttribute('data-defaut') || '|').split('|');
        var sur = d[0], code = d[1];
        var nom = '', fin = '';
        b.getAttribute('data-cal').split(';').some(function (l) {
          var c = l.split('|');
          if (t >= +c[0] && t <= +c[1]) { code = c[2]; sur = c[3]; nom = c[4] || ''; fin = c[5] || ''; return true; }
          return false;
        });
        // N'écrire que ce qui change : l'observateur verrait sinon ses propres écritures.
        if (b.dataset.code === code && b.dataset.vu) return;
        b.dataset.vu = '1';
        b.dataset.code = code;
        b.hidden = !code;
        var rs = b.querySelector('[data-ref="sur"]'), rc = b.querySelector('[data-ref="code"]');
        if (rs && rs.textContent !== sur) rs.textContent = sur;
        if (rc && rc.textContent !== code) rc.textContent = code;
        // 02-11 offre de campagne : nom, fin et remise de la période (ou retour au rendu sobre hors période).
        b.classList.toggle('promo-code--offre', !!nom);
        var po = { nom: nom, jour: fin.split(' ')[0] + ' ', fin: fin.split(' ').slice(1).join(' '), remise: '\u2212' + sur.split(' sur ')[0].replace(/^[-\u2212]\s*/, '').replace(/ /g, '\u00a0') };
        Object.keys(po).forEach(function (k) {
          var e = b.querySelector('[data-ref="' + k + '"]');
          if (e && e.textContent !== po[k]) e.textContent = po[k];
        });
        b.setAttribute('aria-label', sur + ' — ' + (b.dataset.copier || '') + ' ' + code);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', actualiser);
    else actualiser();
    // La fiche re-rend ses blocs au changement de variante : on repasse, une fois par image au plus.
    var attente = false;
    new MutationObserver(function () {
      if (attente) return; attente = true;
      requestAnimationFrame(function () { attente = false; actualiser(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('.promo-code');
      if (!b || b.classList.contains('is-copied')) return;
      copier(b.dataset.code).then(function () {
        var a = b.querySelector('[data-ref="action"]'), ann = b.querySelector('[data-ref="annonce"]');
        var avant = a ? a.textContent : '';
        b.classList.add('is-copied');
        if (a) a.textContent = b.dataset.copie;
        if (ann) ann.textContent = b.dataset.copie;
        setTimeout(function () {
          b.classList.remove('is-copied');
          if (a) a.textContent = avant;
          if (ann) ann.textContent = '';
        }, 2000);
      }).catch(function () {});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
